import React from 'react';
import { loginAndSecurityDetails } from 'Constants';
import {  DashboardSettingLayout } from 'Layouts';
import { DashboardLayoutWithDescription } from 'Pages/Dashboard/Components/LayoutWithDescription';
import { Content } from './Content';

export const LoginAndSecurity = () => {

	return (
		<DashboardSettingLayout>
			<DashboardLayoutWithDescription
				content={<Content/>}
				description={loginAndSecurityDetails}/>
		</DashboardSettingLayout>
	);
};
